"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _TouchableOpacity = _interopRequireDefault(require("react-native-web/dist/cjs/exports/TouchableOpacity"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n          :hover * {\n            color: ", ";\n            fill: ", ";\n            stroke: ", ";\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  * {\n    color: ", ";\n    fill: ", ";\n    stroke: ", ";\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var IconWrapper = function IconWrapper(_ref) {
  var IconComponent = _ref.IconComponent,
      onPress = _ref.onPress,
      children = _ref.children,
      size = _ref.size,
      color = _ref.color,
      hoverColor = _ref.hoverColor,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["IconComponent", "onPress", "children", "size", "color", "hoverColor", "title"]);

  if (onPress) {
    var foo = _react["default"].createElement(_TouchableOpacity["default"], {
      onPress: onPress
    }, _react["default"].createElement(IconComponent, (0, _extends2["default"])({
      size: size,
      color: color,
      hoverColor: hoverColor,
      title: title
    }, rest), children));

    return foo;
  }

  var bar = _react["default"].createElement(IconComponent, (0, _extends2["default"])({
    size: size,
    color: color,
    hoverColor: hoverColor,
    title: title
  }, rest), children);

  return bar;
};

var Icon = (0, _styledComponents["default"])(IconWrapper)(_templateObject(), function (p) {
  return p.color || p.theme.colors.onBackground;
}, function (p) {
  return p.color || p.theme.colors.onBackground;
}, function (p) {
  return p.color || p.theme.colors.onBackground;
}, function (p) {
  return p.hoverColor ? (0, _styledComponents.css)(_templateObject2(), p.hoverColor || p.theme.colors.onBackground, p.hoverColor || p.theme.colors.onBackground, p.hoverColor || p.theme.colors.onBackground) : "";
});
exports.Icon = Icon;